import { ValidateRoute } from "../../routes/ValidRoute";
import TcmContainer from "../TcmContainer";
import AddTcmProject from "../TcmProjects/AddTcmProject";
import EditTcmProject from "../TcmProjects/EditTcmProject";
import TcmProjectList from "../TcmProjects/TcmProjectList";

/* ------ TCM Data Routes ------ */
export const ROUTE_TCM_PROJECTS = {
    plain: 'Tcm-Projects',
    withSlash: '/Tcm-Projects',
    title: 'TCM Projects',
    module: 'ROUTE_TCM_PROJECTS'
};
export const ROUTE_CREATE_TCM_PROJECTS= {
    plain: 'Create',
    withSlash: '/Create',
    title: 'Add a TCM Project', 
    module: 'ROUTE_TCM_PROJECTS',
    create: true
};
export const ROUTE_EDIT_TCM_PROJECTS = {
    plain: ':tcmProjectRecordId',
    // useNav: 'Edit/',
    withSlash: '/:tcmProjectRecordId',
    title: 'Edit a TCM Project',
    module: 'ROUTE_TCM_PROJECTS',
    edit: true
};
/* ------ (end) TCM Data Routes ------ */

export const tcmRoutes = [
    {
        path: ROUTE_TCM_PROJECTS.plain,
        element: <TcmContainer />,
        children: [
            {
                index: true,
                element: <ValidateRoute route={ROUTE_TCM_PROJECTS}><TcmProjectList /></ValidateRoute>,
            },
            {
                path: 'Create',
                element: <ValidateRoute route={ROUTE_CREATE_TCM_PROJECTS}><AddTcmProject /></ValidateRoute>
            },
            {
                path: ROUTE_EDIT_TCM_PROJECTS.plain,
                element: <ValidateRoute route={ROUTE_EDIT_TCM_PROJECTS}><EditTcmProject /></ValidateRoute>
            },
        ],
    },
];